class SpiderIcons extends HTMLElement {
  connectedCallback() {
    const children = Array.from(this.children);

    if (children.length > 0) {
      const count = Math.min(Math.floor(Math.random() * 3) + 5, children.length);
      const indices = new Set();

      while (indices.size < count) {
        indices.add(Math.floor(Math.random() * children.length));
      }

      children.forEach((child, index) => {
        if (indices.has(index)) {
          child?.remove();
          return;
        }

        /** @type {HTMLElement} */ (child).style.top = `${5 + Math.random() * 90}%`;
        /** @type {HTMLElement} */ (child).style.left = `${5 + Math.random() * 90}%`;

        document.body.appendChild(child);
      });
    }
  }
}

if (!customElements.get('spider-icons')) {
  customElements.define('spider-icons', SpiderIcons);
}
